import { render, staticRenderFns } from "./otherScreen.vue?vue&type=template&id=7dbb3ff6&scoped=true"
import script from "./otherScreen.vue?vue&type=script&lang=js"
export * from "./otherScreen.vue?vue&type=script&lang=js"
import style0 from "./otherScreen.vue?vue&type=style&index=0&id=7dbb3ff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb3ff6",
  null
  
)

export default component.exports